import { useFormContext, useWatch } from 'react-hook-form';

import { TippingInput } from '@jane/shared-ecomm/components';
import { useTipSettings } from '@jane/shared-ecomm/hooks';
import { useCheckout } from '@jane/shared-ecomm/providers';

import { useCheckoutPayments } from '../CheckoutPayments/CheckoutPaymentsProvider';
import { DEFAULT_TIP_PAYMENT_METHODS } from '../util/hooks/usePaymentOptions';

export const Tipping = () => {
  const {
    cartLineItems,
    dispatches: { updateTip },
    cart: { reservation_mode },
    store: { delivery_tip_settings, tip_settings },
  } = useCheckout();

  const { control } = useFormContext();
  const pickupMode = useWatch({ control, name: 'pickupOptions.pickupMode' });

  const { selected: selectedPaymentMethod } = useCheckoutPayments();

  const { tipOptions, tipSettings } = useTipSettings({
    reservationMode: reservation_mode,
    pickupMode,
    deliveryTipSettings: (delivery_tip_settings as any) || undefined,
    tipSettings: (tip_settings as any) || undefined,
    selectedPaymentMethod,
    tipPaymentMethods: DEFAULT_TIP_PAYMENT_METHODS,
  });

  const isPercentage = tipSettings?.variant === 'percentage';

  const handleTipChange = (tip: number) => {
    updateTip(tip);
  };

  return (
    <TippingInput
      cartTotal={cartLineItems?.total || 0}
      currentTipAmount={cartLineItems.tipAmount}
      isPercentage={isPercentage}
      onTipChange={handleTipChange}
      tipOptions={tipOptions}
    />
  );
};
